define('dressingroom',['jquery', 'core', 'shuffle', 'touchPunch', 'slickJs', 'modal'], function ($, core) {
    var module = {};
    var messageTimeouts = [];
    var itemRemoveInProgress = false;
    var disableSliderEvents = false;
    var currentSlideIndex = 0;

    var tabsReponsiveSlickBreakpointOption =
    {
        breakpoint: 481,
        settings: {
            infinite: true,
            arrows: false,
            swipe: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 0,
            centerMode: true,
            centerPadding: '60px',
            focusOnSelect: true
        }
    };

    function updateResponsiveSlickBreakpointOption(tabsCount) {
        tabsReponsiveSlickBreakpointOption.settings.slidesToShow = tabsCount == 2 ? 2 : 1;
        tabsReponsiveSlickBreakpointOption.settings.centerMode = tabsCount == 1 ? false : true;
        tabsReponsiveSlickBreakpointOption.settings.centerPadding = tabsCount == 3 ? '60px' : '0';
        return tabsReponsiveSlickBreakpointOption;
    }

    function recalculateMobileTabs(slick) {
        var $slickContainer = $(".js-dressing-room-nav ul");

        if ($slickContainer.slick('getSlick').activeBreakpoint &&
            $slickContainer.slick('slickCurrentSlide') != currentSlideIndex) {
            $slickContainer.slick('slickGoTo', currentSlideIndex);
        }

        var $filterLi = $slickContainer.find("li");
        $filterLi.removeClass('slick-previous-slide');
        if (slick.$slides.length == 3) { //3 slides
            $filterLi.filter('[data-slick-index="' + ($slickContainer.slick('slickCurrentSlide') - 1) + '"]').addClass("slick-previous-slide");
        }
    };

    function filterTabs() {
        var $slickContainer = $(".js-dressing-room-nav ul");
        if ($(".js-dressing-room-nav ul").length == 0) {
            return;
        }

        var $tabsTemplateLi = $('.js-dressing-room-nav-template li');
        var $activeTabLink = $slickContainer.find('li.tab-active a');
        var activeTabName = $activeTabLink.data('show');
        var activeTabHide = $activeTabLink.find('span').text() == 0;

        disableSliderEvents = true;

        //Remove all slides
        var slideExists = true;
        while (slideExists) {
            slideExists = $slickContainer.slick('slickRemove', 0);
        }

        //Add slides again
        var tabsCount = 0;
        $tabsTemplateLi.each(function () {
            var $clonedLi = $(this).clone();
            var $link = $clonedLi.find('a');
            var itemsCount = $link.find('span').text();

            if (itemsCount > 0) {
                tabsCount++;

                $link.click(onDressingRoomFilterLinkClick); //Bind click
                if ($link.data('show') == activeTabName) {
                    $clonedLi.addClass('tab-active');
                } else {
                    $clonedLi.removeClass('tab-active');
                }


                $slickContainer.slick('slickAdd', $clonedLi[0]);
            }
        });

        $slickContainer.slick('slickSetOption', 'responsive', [updateResponsiveSlickBreakpointOption(tabsCount)], true);

        disableSliderEvents = false;

        recalculateMobileTabs($slickContainer.slick('getSlick'));

        //Select first slide as active
        if (activeTabHide) {
            currentSlideIndex = 0;
            var intervalId = setInterval(function() {
                if (!itemRemoveInProgress) {
                    $slickContainer.find('a:first').click();
                    clearInterval(intervalId);
                }
            }, 50);
        }
    }

    function onDressingRoomFilterLinkClick(e) {
        e.preventDefault();
        var $this = $(this);
        var tabFilterName = $this.data("show");

        var $slickContainer = $(".js-dressing-room-nav ul");
        var $dressingRoomContent = $(".js-dressing-room");
        var $filterLinks = $(".js-dressing-room-nav a");

        var $filterSlickLinks = $slickContainer.slick('getSlick').$slides.find('a');
        currentSlideIndex = $filterSlickLinks.index($filterSlickLinks.filter('[data-show="' + tabFilterName + '"]'));

        $('.slick-slider').slick('slickGoTo', currentSlideIndex);

        //Add tab-active
        $filterLinks.parent('li').removeClass("tab-active");
        $filterLinks.filter('[data-show="' + tabFilterName + '"]').parent('li').addClass("tab-active");

        $dressingRoomContent.shuffle('shuffle', function ($el) {
            return $el.data('item-' + tabFilterName);
        });
    };

    function getShuffleSortOptions() {
        var sort = $(".js-dressing-room-sort").val(),
            reverse,
            opts;

        switch (sort) {
            case "item-added":
                reverse = true;
                break;
            case "item-designer":
                reverse = false;
                break;
            default:
                reverse = false;
        }

        opts = {
            reverse: reverse,
            by: function ($el) {
                return (reverse ? $el.data('item-outfit') : !$el.data('item-outfit')) + $el.data(sort);
            }
        };

        return opts;
    }

    module.dressingRoomFiltersNavigation = function (context) {
        var $dressingRoomSort = context.andFind(".js-dressing-room-sort");
        var $dressingRoomMobileSort = context.andFind(".js-dressing-room-mobile-sort");
        var $dressingRoomContent = context.andFind(".js-dressing-room");
        var $slickContainer = context.andFind(".js-dressing-room-nav ul");
        var $filterLi = $slickContainer.find("li");
        var $filterLinks = $filterLi.find("a");
        var activeTabFilterName = $filterLi.filter(".tab-active").find('a').data("show");

        if (!$dressingRoomContent.length) {
            return;
        }

        $dressingRoomContent.shuffle({
            itemSelector: 'li',
            //Initial filter
            group: function($el) {
                return $el.data('item-' + activeTabFilterName);
            },
            initialSort: getShuffleSortOptions()
        });

        $dressingRoomContent.on('removed.shuffle', function () {
            itemRemoveInProgress = false;
        });

        $filterLinks.click(onDressingRoomFilterLinkClick); //Bind click

        $slickContainer.slick({
            infinite: false,
            arrows: false,
            swipe: false,
            slidesToScroll: 1,
            slidesToShow: 3,
            speed: 0,
            centerMode: false,
            initialSlide: 0,
            focusOnSelect: true,
            responsive: [updateResponsiveSlickBreakpointOption($filterLinks.length)]
        });

        $slickContainer.on('setPosition', function (event, slick) {
            if (disableSliderEvents) {
                return;
            }

            recalculateMobileTabs(slick);
        });

        $slickContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (disableSliderEvents || currentSlide === nextSlide) {
                return;
            }

            $filterLi
                .filter("[data-slick-index='" + (nextSlide) + "']")
                .find("a")
                .click();
        });

        //Trigger filtering
        $dressingRoomSort.change(function () {
            var currentSortByVal = $(this).val();

            $dressingRoomMobileSort.prop('checked', false);
            $dressingRoomMobileSort.filter('[value="'+ currentSortByVal + '"]').prop('checked', true);

            $(".js-dressing-room").shuffle('sort', getShuffleSortOptions());
        });

        $dressingRoomMobileSort.change(function() {
            var currentSortByVal = $(this).val();

            $dressingRoomSort.val(currentSortByVal);
            $dressingRoomSort.change();
        });
    };

    module.sortCover = function (context) {
        var $outfitContent = $('.js-outfit-container', context);

        if ($outfitContent.length === 0) {
            return;
        }
        $outfitContent.shuffle({
            itemSelector: 'li'
        });

        $outfitContent.shuffle('sort', {
            reverse: false,
            by: function ($el) {
                return $el.attr('data-sort-key');
            }
        });

        $('.js-set-cover', context).on('click', function () {
            var oldKey = $(this).closest('li').attr('data-sort-key'),
                newKey = "0" + oldKey.substr(1, oldKey.length),
                keyForFirstEl = "1" + $('.cover-set').attr('data-sort-key').substr(1, this.length);

            $('.cover-set').removeClass('cover-set').attr('data-sort-key', keyForFirstEl);
            $(this).closest('li').addClass('cover-set').attr('data-sort-key', newKey);

            var imageUrl = $(this).closest('li').find('.js-dressing-room-item-image').attr('src');
            var $pinterestShareLink = $('.js-share-pinterest');
            var pinterestShareLinkTemplate = $pinterestShareLink.data('url-template');
            $pinterestShareLink.attr('href', pinterestShareLinkTemplate.replace('{imageUrl}', imageUrl));

            $outfitContent.shuffle('sort', {
                reverse: false,
                by: function ($el) {
                    return $el.attr('data-sort-key');
                }
            });
        });
    };

    module.scrollAndFixOutfitForm = function (context) {
        var outfitWRapper = $('.outfit-modal-wrapper', context);
        outfitWRapper.on('scroll', function () {
            if ($('.outfit-preview').offset().top < -131) {
                $('html').addClass('fix-outfit-form');
            } else {
                $('html').removeClass('fix-outfit-form');
            }
        });
    };

    module.onOutfitSelectAction = function (context) {
        function setItemFieldValue(element) {
            var $element = $(element);
            var $itemContainer = $element.closest('.product-box');

            var itemSelectedFieldName = $element.data('item-selected-field-name');
            var $itemSelectedField = $itemContainer.find('[name="' + itemSelectedFieldName + '"]');
            var isItemSelected = $itemSelectedField.val() == 1;

            var itemSizeFieldName = $element.data('item-size-field-name');
            var $itemSizeField = $itemContainer.andFind('[name="' + itemSizeFieldName + '"]');
            var itemSizeValue = $itemSizeField.val();

            var itemFieldSelectorClass = $element.data('item-field-selector-class');
            var $itemField = $itemContainer.andFind('.' + itemFieldSelectorClass);
            $itemField.val(isItemSelected ? itemSizeValue : "");
        }

        context.andFind('.js-select-outfit-item-button').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            var $itemContainer = $this.closest('.product-box');
            var itemSelectedFieldName = $this.data('item-selected-field-name');

            $itemContainer.toggleClass('selected');
            $itemContainer.find('[name="' + itemSelectedFieldName + '"]').val($itemContainer.hasClass('selected') ? 1 : 0);

            setItemFieldValue(this);

            $('.js-select-all-outfit-items-checkbox').prop('checked', $('.product-box.js-available').length == $('.product-box.selected').length);

            var selectedItemsCount = $('.product-box.selected').length;
            var $selectedItemsCountDiv = $('.js-selected-look-items-text');
            switch (selectedItemsCount) {
                case 0:
                    $selectedItemsCountDiv.html($selectedItemsCountDiv.data('no-items-text'));
                    break;
                case 1:
                    $selectedItemsCountDiv.html($selectedItemsCountDiv.data('one-item-text'));
                    break;
                default:
                    $selectedItemsCountDiv.html($selectedItemsCountDiv.data('many-item-text-template').replace('{0}', selectedItemsCount));
            }
        });

        context.andFind('.js-outfit-item-size-dropdown').change(function () {
            var $this = $(this);
            var $itemContainer = $this.closest('.product-box');
            var $selectItemButton = $itemContainer.find('.js-select-outfit-item-button');

            if ($itemContainer.hasClass('selected') || !$this.val()) {
                setItemFieldValue($selectItemButton);
            } else {
                $selectItemButton.click();
            }
        });

        context.andFind('.js-select-all-outfit-items-checkbox').change(function () {
            var $this = $(this);

            if ($this.is(':checked')) {
                var $notSelectedItemDetailsContainers = $('.product-box:not(.selected)');
                $notSelectedItemDetailsContainers.find('.js-select-outfit-item-button').click();
            } else {
                var $selectedItemDetailsContainers = $('.product-box.selected');
                $selectedItemDetailsContainers.find('.js-select-outfit-item-button').click();
            }
        });
    };

    module.onOpenModal = function (context) {
        var $control = context.andFind('.js-open-modal');
        if ($control.length && $control.hasClass('js-modal')) {
            $control.click();
        }
    };

    core.scopes.on('updateDressingRoom', function (event, listItem) {
        var $dressingRoomContent = $(".js-dressing-room"),
            $outfit;

        if (listItem.isNew) {
            $outfit = $(listItem.newOutfitHtml);

            $dressingRoomContent.append($outfit);
            $dressingRoomContent.shuffle('appended', $outfit);

            $dressingRoomContent.on('layout.shuffle', function () {
                $dressingRoomContent.off('layout.shuffle');
                $('.js-dressing-room-nav .js-dressing-room-outfits-link').click();
            });

            core.scopes.update($outfit);

            var outfitCount = $('.js-dressing-room-outfit-count');
            if (outfitCount.length) {
                outfitCount.html(parseInt(outfitCount.filter(':first').text()) + 1);
            }

            messageTimeouts[parseInt($outfit.find(".js-outfit").data("id"))] = setTimeout(function() {
                $outfit.find('.js-product-status').removeClass('product-status-active');
                $outfit.find('.js-hide-after-4-seconds').removeClass('visible');
            }, 4000);
        } else {
            $outfit = $('.js-dressing-room-' + listItem.id + '-list-id');

            if (!listItem.allItemsHaveStock) {
                $outfit.find('.js-outfit').addClass('outfit-is-out-of-stock');
            }

            $outfit.attr('data-item-stylist-picks', listItem.stylistPicks); //Is outfit selected by stylist

            $outfit.find('.js-count-after-adding').html(listItem.itemsCount);
            $outfit.find('.js-outfit-items-text').text(listItem.itemsCount == 1 ? 'Item' : 'Items');

            if (listItem.itemsCount == 1) {
                $outfit.find('.js-dressing-room-item-status-outfit-empty').remove();
            }

            //If outfit was empty, add image
            if (!$outfit.find('img').attr('src')) {
                $outfit.find('img').attr('src', listItem.pictureUrl);
            }

            $outfit.find('.js-dressing-room-item-status').removeClass('visible');
            $outfit.find('.js-product-status').addClass('product-status-active');
            $outfit.find('.js-dressing-room-item-status-added-to-outfit').addClass('visible');

            clearTimeout(messageTimeouts[parseInt(listItem.id)]);
            messageTimeouts[parseInt(listItem.id)] = setTimeout(function() {
                var selectedForYou =  $outfit.find(".js-dressing-room-item-status-stylist-pick");
                if (selectedForYou.length !== 0) {
                    $outfit.find(".js-dressing-room-item-status-stylist-pick").addClass('visible');
                } else {
                    $outfit.find('.js-product-status').removeClass('product-status-active');
                }
                $outfit.find('.js-dressing-room-item-status-added-to-outfit').removeClass('visible');
            }, 4000);

            $('.js-dressing-room-nav .js-dressing-room-outfits-link').click();
        }

        var edittedCount = $('.js-dressing-room-edited-item-count');
        if (edittedCount.length) {
            edittedCount.html(listItem.stylistEditedCount);
        }

        filterTabs();
    });

    core.scopes.on("clearDressingRoom", function (event, data, context) {
        var $items = $('.js-dressing-room-item');

        $(".js-dressing-room").shuffle('remove', $items);

        var $dressingRoomIcon = $('.js-dressing-room-icon');
        $dressingRoomIcon.attr('data-cart-items', 0);
        $dressingRoomIcon.addClass('empty');

        var counts = $('.js-dressing-room-outfit-count, .js-dressing-room-edited-item-count, .js-dressing-room-all-item-count');
        if (counts.length) {
            counts.html(0);
        }

        $("html, body").addClass('dressing-room-empty');
        $('.js-dressing-room-clear-all-link').addClass('hide-container');
        $('.js-dressing-room-sort-by-container').addClass('hide-container');
        $('.js-no-dressing-room-items-container').removeClass('hide-container');

        filterTabs();
    });


    core.scopes.on("removeDressingRoomItem", function (event, data, context) {
        if (data.isOutfit) {
            var outfitCount = $('.js-dressing-room-outfit-count');
            if (outfitCount.length) {
                outfitCount.html(parseInt(outfitCount.filter(':first').text()) - 1);
            }
        }

        if (data.stylistEdited) {
            var edittedCount = $('.js-dressing-room-edited-item-count');
            if (edittedCount.length) {
                if (data.stylistEditedCount !== undefined && data.stylistEditedCount > -1) {
                    edittedCount.html(data.stylistEditedCount);
                } else {
                    edittedCount.html(parseInt(edittedCount.filter(':first').text()) - 1);
                }
            }
        }

        var allItemCount = $('.js-dressing-room-all-item-count');
        if (allItemCount.length) {
            allItemCount.html(data.itemCount);
        }

        var isLastItem = $('.js-dressing-room-item').length == 1;

        itemRemoveInProgress = true;
        $(".js-dressing-room").shuffle('remove', $(data.itemToRemove));

        var $dressingRoomIcon = $('.js-dressing-room-icon');
        $dressingRoomIcon.attr('data-cart-items', data.itemCount);
        if (isLastItem) {
            $("html, body").addClass('dressing-room-empty');
            $('.js-dressing-room-clear-all-link').addClass('hide-container');
            $('.js-dressing-room-sort-by-container').addClass('hide-container');
            $('.js-no-dressing-room-items-container').removeClass('hide-container');
            $dressingRoomIcon.addClass('empty');
        } else {
            $dressingRoomIcon.removeClass('empty');
        }

        filterTabs();
    });

    core.scopes.on("removeOutfitItem", function (event, data, context) {
        var itemsCountAfterDelete = $(".js-outfit-container li").length - 1;
        var $itemToRemove = $(data.itemToRemove);
        var $itemProductBox = $itemToRemove.find('.product-box');
        var itemIsSelected = $itemProductBox.hasClass('selected');

        if ($itemProductBox.hasClass('js-available') && $('.product-box.js-available').length == 1) {
            $('.js-remove-if-no-selectable-items').remove();
        }

        if (itemIsSelected) {
            $itemProductBox.removeClass('js-available');
            $itemToRemove.find('.js-select-outfit-item-button').click();
        }

        //Remove item
        $(".js-outfit-container").shuffle('remove', $itemToRemove);

        var $dressingRoomIcon = $('.js-dressing-room-icon');
        $dressingRoomIcon.attr('data-cart-items', data.itemCount);
        if (data.itemCount == 0) {
            $dressingRoomIcon.addClass('empty');
        } else {
            $dressingRoomIcon.removeClass('empty');
        }

        if (itemsCountAfterDelete === 1) {
            $('.js-remove-outfit-item').addClass('hide-container');
            $('.js-remove-outfit-last-item').removeClass('hide-container');
        } else if (itemsCountAfterDelete === 0) {
            core.ui.lock('screen', undefined, true);

            if (data.urlAfterOutfitRemove) {
                window.location = data.urlAfterOutfitRemove;
            }
            setTimeout(function () {
                $('.js-outfit-empty-message').removeClass('hide-container');
                $('.js-outfit-items-content').remove();
            }, 500);
        }

        filterTabs();
    });

    $(document).ready(function () {
        core.scopes.addHandler("*", function (context) {
            module.dressingRoomFiltersNavigation(context);
            module.sortCover(context);
            module.onOutfitSelectAction(context);
            module.onOpenModal(context);
            module.scrollAndFixOutfitForm(context);
        });
    });
});
